import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Home2 from "./Home2";
import Type from "./Type";
import ImageSlider from "./ImageSlider";
import Design from "../Design/Design";

function Home() {
    return (
        <section>
            <Container fluid id="home">
                <Row className="home-section">
                    <ImageSlider></ImageSlider>
                </Row>
                <Row>
                    <div className="general-title">
                        <h2 className="purple">Who We Are</h2>
                    </div>
                </Row>
                <Row>
                    <Col className="about-caption text-center">
                        <p style={{ color: "#3e5172" }}>
                            Welcome to  <strong className="purple">21 Interior Studio</strong>, where architectural innovation meets creative excellence. As a leading firm in the field of architectural design, we specialize in transforming spaces into functional, inspiring environments that enrich lives and enhance communities.
                        </p>
                        <div className="space-bottom-2x"></div>
                    </Col>
                </Row>
                <Row>
                    <Col className="about-caption text-center">
                        <p style={{ color: "#3e5172" }}>
                            Explore our diverse portfolio encompassing <strong className="purple">residential, commercial, institutional, and cultural projects</strong>. Each project showcases our commitment to excellence and our passion for crafting spaces that resonate.</p>
                        <div className="space-bottom-2x"></div>
                        <div style={{ paddingLeft: 50, textAlign: "center" }}>
                            <Type />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Design></Design>
                </Row>
            </Container>
            <Home2 />
        </section>
    );
}

export default Home;
